






































import { computed, defineComponent } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import config from "@/config";
import BaseDownloadButton from "@/components/BaseDownloadButton";
import BaseImage from "@/components/BaseImage";
import PlayButton from "@/components/PlayButton";

export default defineComponent({
  name: "ContentFeedGalleryItem",
  components: { PlayButton, BaseImage, BaseDownloadButton },
  props: {
    file: { required: true, type: Object as () => ContentFile },
    activeFeedItem: { required: true, type: Boolean },
    clicked: { required: true, type: Boolean },
    activeFileId: { required: true, type: String },
    isFullScreen: { type: Boolean, default: false },
    videoAutoPlay: { type: Boolean, default: true },
  },
  setup(props) {
    const active = computed(
      () => props.activeFeedItem && props.activeFileId === props.file.id && (props.videoAutoPlay || props.clicked)
    );
    const isPlayableVideo = computed(
      () => isVideoFile(props.file) && ["NEW", "CONVERTING"].indexOf(props.file.processingStatus) === -1
    );
    const canDownloadFiles = computed(() => config.featureDownload);
    const videoSrc = computed(() => MediaFilesController.getVideoUrl(props.file.urlPart));
    const imageSrc = computed(() =>
      isVideoFile(props.file)
        ? MediaFilesController.getVideoThumbnail(props.file.urlPart, "1080p")
        : MediaFilesController.getImageThumbnail(props.file.urlPart, "1080p")
    );
    const fileUrl = computed(() => MediaFilesController.getFileUrl(props.file.urlPart));

    return { active, isPlayableVideo, videoSrc, imageSrc, fileUrl, canDownloadFiles };
  },
});
